import loadable from '@loadable/component'
import React, { useEffect } from 'react'

import { track } from '~/utils/tracking'
const ResultsCallout = loadable(() => import('@uswitch/comms-ui.results-callout'), {
  resolveComponent: (components) => components.ResultsCallout
})

const containerStyle = {
  mb: 'sm',
  '& h3': {
    lineHeight: ['1.3', '1.3', '24px'],
    fontSize: [20, 20, 24]
  }
}

const RevertToPostcodeResultsMessage = ({ visibility }) => {
  useEffect(() => {
    if (visibility) {
      track('Broadband - availability for postcode only message shown', 'no serviceable results for address provided')
    }
  }, [visibility])

  if (!visibility) {
    return null
  }

  return (
    <div sx={containerStyle}>
      <ResultsCallout />
    </div>
  )
}

export default RevertToPostcodeResultsMessage
